import { render } from "./Form.vue?vue&type=template&id=f05488e2&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=f05488e2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f05488e2"

export default script